import { registerBuilderRetailerBrandTileSection } from "./components/registerBuilderRetailerBrandTileSection";
import { registerBuilderRetailerProductTileSection } from "./components/registerBuilderRetailerProductTileSection";

export const registerRetailerComponents = () => {
  registerBuilderRetailerProductTileSection();
  registerBuilderRetailerBrandTileSection();
};
